module.exports = __webpack_public_path__ + "img/79014908000104.1de48def.png";